/** Округление дозы до 2 знаков после запятой. */
export function normalizeDoseValue(v) {
  if (v == null || v === '') return null;
  const n = Number(v);
  if (!Number.isFinite(n)) return null;
  return Math.round(n * 100) / 100;
}

/** Целое число фракций, не меньше 1. */
export function normalizeFractionsValue(v) {
  if (v == null || v === '') return null;
  const n = Number(v);
  if (!Number.isFinite(n)) return null;
  return Math.max(1, Math.round(n));
}

/** D = d × nf; null, если d или nf не заданы. */
export function computeTotalAbsorbedDose(dosePerFraction, numberOfFractions) {
  const d = normalizeDoseValue(dosePerFraction);
  const nf = normalizeFractionsValue(numberOfFractions);
  if (d == null || nf == null) return null;
  return normalizeDoseValue(d * nf);
}

/**
 * Суммарная доза по нескольким этапам AdaptiveRT: Σ(dᵢ × nfᵢ).
 * @param {Array<{ dose_per_fraction?: number|null, number_of_fractions?: number|null }|null|undefined>} fractionations
 */
export function sumTotalAbsorbedDose(fractionations) {
  if (!Array.isArray(fractionations) || !fractionations.length) return null;
  let sum = 0;
  let hasAny = false;
  for (const f of fractionations) {
    const stageD = computeTotalAbsorbedDose(f?.dose_per_fraction, f?.number_of_fractions);
    if (stageD == null) continue;
    hasAny = true;
    sum += stageD;
  }
  return hasAny ? normalizeDoseValue(sum) : null;
}
